import React, {FC, ReactElement} from 'react';
import {useMediaQuery, useTheme} from "@mui/material";

export enum ScreenType {
    XS,
    SM,
    MD,
    LG,
    XL,
}

export const WithScreenType: FC<{ render: (type: ScreenType) => ReactElement }> = ({render}): ReactElement => {
    const theme = useTheme();
    const screenExtraLarge = useMediaQuery(theme.breakpoints.only('xl'));
    const screenLarge = useMediaQuery(theme.breakpoints.only('lg'));
    const screenMedium = useMediaQuery(theme.breakpoints.only('md'));
    const screenSmall = useMediaQuery(theme.breakpoints.only('sm'));

    let type: ScreenType;
    if (screenExtraLarge) {
        type = ScreenType.XL;
    } else if (screenLarge) {
        type = ScreenType.LG;
    } else if (screenMedium) {
        type = ScreenType.MD;
    } else if (screenSmall) {
        type = ScreenType.SM;
    } else {
        type = ScreenType.XS;
    }
    return <>
        {render(type)}
    </>
};